import {AbstractPmsApiService} from "./abstract.service";
import {GuestNote} from "../models";

/**
 * @class GuestNotePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<GuestNote>}
 */
export class GuestNotePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/guest/:guestId/note(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {GuestNote}
     * @protected
     */
    newModel(attributes, ...params) {

        return new GuestNote(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Guest=} guest
     * @returns {Promise.<PaginationCollection<GuestNote>>}
     */
    get(params = {}, guest = null) {

        const url = this.url({guestId: guest ? guest.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestNote} guestNote
     * @param {Guest} guest
     * @returns {Promise.<GuestNote>}
     */
    create(guestNote, guest) {

        const url = this.url({guestId: guest.id});

        return this.http
            .post(url, guestNote.toObjectExcept('guest', 'user'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestNote} guestNote
     * @returns {Promise.<GuestNote>}
     */
    update(guestNote) {

        const url = this.url({
            guestId: guestNote.guest.id,
            id: guestNote.id
        });

        return this.http
            .put(url, guestNote.toObjectExcept('guest', 'user'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestNote} guestNote
     * @returns {Promise.<boolean>}
     */
    delete(guestNote) {

        const url = this.url({
            guestId: guestNote.guest.id,
            id: guestNote.id,

        });

        if (!!guestNote.property_id) {

            return this.http
                .post(url,
                    {
                        property_id: guestNote.property_id
                    },
                    {
                        headers: this.authHeaders
                    },
                )
                .then(this.getStatusExtractor())
                .catch(this.getErrorHandler());
        }

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/guest-note.service.js